export enum LinkDisplayOptionEnum{
    iconAndLinkText,
    iconOnly,
    linkTextOnly
}
